<template>
  <div>
    <cookie-law theme="pirates">
      <div slot="message">
        We use cookies 🍪 because pirates love 'em and this ensures that you get the best experience of this website. If you want to learn more, visit our
        <router-link to="/privacy" target="_blank">privacy page.</router-link>
      </div>
    </cookie-law>

    <img class="bg-footer" src="@/../images/bg-footer.svg" alt />
    <footer>
      <div class="container">
        <router-link to="/" class="footer-logo button">
          <img src="@/../images/logopnpbottom.svg" alt />
        </router-link>
        <nav class="menu">
          <ul>
            <li>
              <a href="http://fb.com/petsnpirates"
                target="_blank"
                @click="track('facebook', 'Footer')"
                v-tooltip="'Follow us on Facebook'">Facebook</a>
            </li>
            <li>
              <router-link to="/privacy">Privacy policy</router-link>
            </li>
            <li>
              <a href="mailto:ahoy@petsnpirates.com" class="button">Contact us</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="container">
        <p class="small">© 2020 Camillo Addis &amp; Mario Brioschi. All rights reserved.</p>
      </div>
    </footer>
  </div>
</template>

<script>
import CookieLaw from "vue-cookie-law";
export default {
  components: { CookieLaw }
};
</script>

<style lang="scss">
.bg-footer {
  margin: 10rem 0 0 0;
  display: block;
}

footer {
  position: relative;
  padding: 0.5rem 0 4rem 0;
  margin-top: -0.5rem;
  background-color: #25768d;
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    text-align: center;
    @media screen and (min-width: $tablet) {
      flex-direction: row;
      text-align: inherit;
    }
    .footer-logo img {
      height: $logo-height-desktop;
      width: auto;
    }
    nav ul {
      list-style: none;
      padding: 0;
      li {
        @media screen and (min-width: $tablet) {
          display: inline-block;
          margin-left: 2rem;
        }
        margin-top: 1rem;
        a {
          color: white;
          font-size: 0.9rem;
          text-decoration: none;
          font-family: "Raleway", Helvetica, arial, sans-serif;
          text-transform: uppercase;
          cursor: pointer;
        }
      }
    }
    p.small {
      color: white;
      font-size: smaller;
      margin-top: 3rem;
    }
  }
}
.Cookie--pirates {
  background: $green;
  color: white;
  font-family: "Raleway", Helvetica, arial, sans-serif;
  padding: 1rem;
  a{
    color: white;
  }
  .Cookie__button{
     background-color: transparent;
     color:white;
     border:1px solid white;
     padding: .5rem 1rem; 
     outline: none;
     &:hover{
       background-color: white;
       color: $green;
     }
    }
}
</style>